// External
import { gql } from "@apollo/client";

export const getRatingLogsQuery = gql`
  query getRatingLogs($input: RatingLogsInput!) {
    documentation {
      internalToolsData {
        progressReport {
          ratingLogs(input: $input) {
            courseName
            gradeName
            studentName
            teacherName
            subjectName
            learningGoalLabel
            criteriaLabel
            oldRatingValue
            newRatingValue
            updatedAt
          }
        }
      }
    }
  }
`;
